// Google Analytics 4 event tracking
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Track Calendly CTA clicks
export const trackCalendlyClick = (source) => {
  trackEvent('calendly_click', {
    event_category: 'conversion',
    event_label: source,
    value: 1
  });
};

// Track contact form submission
export const trackContactSubmission = () => {
  trackEvent('contact_form_submit', {
    event_category: 'conversion',
    value: 1
  });
};

// Track chatbot interaction
export const trackChatbotOpen = () => {
  trackEvent('chatbot_open', {
    event_category: 'engagement',
    value: 1
  });
};

export const trackChatbotMessage = () => {
  trackEvent('chatbot_message', {
    event_category: 'engagement',
    value: 1
  });
};

// Track blog post view
export const trackBlogView = (slug, title) => {
  trackEvent('blog_view', {
    event_category: 'content',
    event_label: title,
    page_path: `/blog/${slug}`
  });
};

// Track industry page view
export const trackIndustryView = (slug, title) => {
  trackEvent('industry_page_view', {
    event_category: 'content',
    event_label: title,
    page_path: `/industries/${slug}`
  });
};
